import { ofType, ActionsObservable } from "redux-observable";
import { mergeMap, flatMap } from "rxjs/operators";
import { from } from "rxjs";
import { format } from "one-util-date";
import { ErrorObject } from "one-state-error/src/errorobject";

import { addAction as addErrorAction } from "one-state-error/src/actions";

export const enum Types {
  STORE_DISPOSITION_CODE = "store-disposition-code",
}

/**
 * This Function posts data to dispositionWrite api
 * @param context contains settings.json etc...
 */
export const storeDispositionCode =
  (context: any) => (action$: ActionsObservable<any>) => {
    const errorTime = format(new Date(), "LT");
    const errorDate = format(new Date(), "LL");
    const {
      server,
      log,
      settings: {
        epicendpoints: { apitoken, dispositionWrite },
        uisettings: {
          dashboardapiconfig: {
            disposition : dispositionApi
          }
      }
      }
    } = context;
    return action$.pipe(
      ofType(Types.STORE_DISPOSITION_CODE),
      mergeMap((action: any) => {
        /**
         * @param dataresponse contains the patient global search request
         */
        const dataresponse: any = action.payload;
        log.debug("one-epics", "store-disposition-code request", dataresponse);
        const postDispositionCode = (payload: any) => {
          let headers = new Headers();
          headers.set("Authorization", "Basic " + apitoken?.token);
          /**
           * Invoking Dispositon API
           */
          const response = server
            .put({
              headers,
              path: dispositionWrite,
              data: payload,
            })
            .then((responsefound: any) => responsefound)
            .catch((responseresult: any) => {
              log.error(
                "one-epic",
                "store-disposition-code Error",
                responseresult
              );
              /**
               * Creating the error object for dispositon API in case of failure scenarios.
               */
              let pgserror: ErrorObject = {
                source: "Store Disposition Code",
                type: "error",
                status: responseresult?.status,
                erroritems: responseresult?.errors,
                error_date: errorDate,
                error_time: errorTime,
              };
              return pgserror;
            });
          log.debug("one-epics", "store-disposition-code response", response);
          return from(response);
        };
        //Checking whether to invoke dispostion api or not based on settings.json
        if (!dispositionApi) return []
        return postDispositionCode(dataresponse).pipe(
          flatMap((response: any) => {
            const actions: any = [];

            if (response && (response.status >= 400 || response.type == "error")) {
              actions.push(addErrorAction(response.error));
            }

            return actions;
          })
        );
      })
    );
  };
